import { render, staticRenderFns } from "./MultiprojectContainer.vue?vue&type=template&id=4fe74052&scoped=true&"
import script from "./MultiprojectContainer.vue?vue&type=script&lang=js&"
export * from "./MultiprojectContainer.vue?vue&type=script&lang=js&"
import style0 from "./MultiprojectContainer.vue?vue&type=style&index=0&id=4fe74052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe74052",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
